module.exports = __webpack_public_path__ + "d8640a51baee568f7b1b2841b65039d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Source/baikal-shadow.png
// module id = 405
// module chunks = 0